import { User } from 'models/User';
import { Board } from 'models/Board';
import { Resource, TYPE_FAILURE, TYPE_LOADING, TYPE_SUCCESS } from 'models/Resource';
import { BoardItemCard } from 'components/common/BoardItemCard';
import { LoadMore } from 'components/common/LoadMore';
import { Spinner } from 'components/common/Spinner';
import { BoardEmpty } from 'components/common/BoardEmpty';

import styles from './styles.module.css';

type Props = {
    user: User
    board: Resource<Board>
    isLogin: boolean
    authorize: () => void
    loadMore: () => void
}

export const BoardItemCardList: React.FC<Props> = ({
    user,
    board,
    isLogin,
    authorize,
    loadMore,
}) => (
    <div className={styles.container}>
        { (() => {
            switch(board.data.type) {
                case TYPE_SUCCESS: {
                    return <List
                        user={user}
                        board={board.data.value}
                        isLogin={isLogin}
                        authorize={authorize}
                        loadMore={loadMore} />
                }
                case TYPE_FAILURE: {
                    return null
                }
                case TYPE_LOADING: {
                    return <Spinner className={styles.loading} />
                }
            }
        })() }
    </div>
)

const List: React.FC<{
    user: User
    board: Board
    isLogin: boolean
    authorize: () => void
    loadMore: () => void
}> = ({
    user,
    board,
    isLogin,
    authorize,
    loadMore,
}) => {
    if (board.isEmpty) {
        return (<BoardEmpty />)
    }

    return (
        <>
            {
                board.items.map(it =>
                    <div className={styles.item} key={it.id}>
                        <BoardItemCard
                            user={user}
                            item={it}
                            boardAuthorized={board.authorized}
                            isLogin={isLogin}
                            onClickReload={authorize}
                            key={it.id} />
                    </div>
                )
            }
            {
                board.hasMore &&
                    <LoadMore loadMore={loadMore} />
            }
        </>
    )
}